import { useState } from "react";
import { useData } from "@/hooks/useData";
import { InformationSource } from "@/types/information-source/information-source.types";
import { useInformationSourceFilters } from "./useInformationSourceFilters";

export const useInfoSourceTable = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showArchived, setShowArchived] = useState(false);
  const [nameFilters, setNameFilters] = useState<string[]>([]);
  const [yearFilters, setYearFilters] = useState<string[]>([]);

  const {
    data: infoSources,
    loading,
    refetch,
  } = useData<InformationSource>({
    collectionName: "setup_infoSources",
  });

  const { filteredSources, getUniqueOptions } = useInformationSourceFilters({
    infoSources,
    searchTerm,
    showArchived,
    nameFilters,
    yearFilters,
  });

  const clearFilters = () => {
    setSearchTerm("");
    setNameFilters([]);
    setYearFilters([]);
  };

  const nameOptions = getUniqueOptions("name");
  const yearOptions = getUniqueOptions("year");

  return {
    infoSources,
    filteredSources,
    loading,
    refetch,
    searchTerm,
    setSearchTerm,
    showArchived,
    setShowArchived,
    nameFilters,
    setNameFilters,
    yearFilters,
    setYearFilters,
    clearFilters,
    nameOptions,
    yearOptions,
  };
};
